export function formatPhone(phoneNumber = "") {
  if (!phoneNumber) return "";
  // Remover caracteres não numéricos
  const numbers = phoneNumber.replace(/\D/g, "");

  // Retornar o número formatado
  return `+${numbers}`;
}
